import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { IHiddenFields, IInstitutionContext } from '../../models';

@Injectable({ providedIn: 'root' })
export class InstitutionsService {
  private http = inject(HttpClient);

  public hiddenFields = new BehaviorSubject<IHiddenFields>(null);

  private _baseUrl = '/api/institutions';
  private _subject = new BehaviorSubject<IInstitutionContext>(null);
  private _obs = this._subject.asObservable();

  constructor() {
    this.http
      .get<IInstitutionContext>(this._baseUrl)
      .pipe(
        map((context) => {
          this.addStyleSheetToPage(context);
          this._subject.next(context);
          this.hiddenFields.next(
            context.hiddenFields.reduce(
              (pv: IHiddenFields, cv: { key: string; value: string }) => {
                if (!pv[cv.key]) {
                  pv[cv.key] = {};
                }
                pv[cv.key][cv.value] = undefined;
                return pv;
              },
              {},
            ),
          );
        }),
      )
      .subscribe();
  }

  get context(): Observable<IInstitutionContext> {
    return this._obs.pipe(filter((i) => !!i));
  }

  private addStyleSheetToPage(context: IInstitutionContext) {
    const link = document.createElement('link');
    link.href = context.styleSheetPath;
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.media = 'screen,print';
    document.getElementsByTagName('head')[0].appendChild(link);
  }
}
